import { connect } from 'react-redux';
import { hasUserSessionStore, getUserSessionStore } from '@zillow/user-session-store-core';

/**
 * Combines global state (if exists) with local state before passed off to mapStateToProps.
 * @param {Function} selector - mapper of combined state to plain object to be merged into component props
 * @param {String} globalKey - optional namespacing key for global state values
 * @return {Function} mapStateToProps state to object props mapper
 */
function combineUserSessionStateToProps(selector, globalKey) {
  if (globalKey === void 0) {
    globalKey = '';
  }
  return function (localState, localOwnProps) {
    if (typeof selector === 'undefined') {
      throw new Error('selector not specified');
    }
    var globalState = hasUserSessionStore() ? getUserSessionStore().getState() : {};
    if (globalKey !== '') {
      var _Object$assign;
      return selector(Object.assign({}, localState, (_Object$assign = {}, _Object$assign[globalKey] = globalState, _Object$assign)), localOwnProps);
    }
    return selector(Object.assign({}, globalState, localState), localOwnProps);
  };
}

/**
 * UserSession wrapper for redux connect.
 * @param {Function} mapStateToProps - (state, ownProps) => {...} (must return object)
 * @return {Class} higher-order React component class
 */
function connectToUserSession(mapStateToProps, mapDispatchToProps, mergeProps, options) {
  return connect(function (state) {
    return combineUserSessionStateToProps(mapStateToProps)(state);
  }, mapDispatchToProps, mergeProps, Object.assign({
    pure: false
  }, options) // prevent memoization by default
  );
}

export default connectToUserSession;
export { combineUserSessionStateToProps };
